import React, { Component } from 'react'
import { Col, Form, Input, Row } from 'antd'
import { get } from 'lodash'

import { defaultFormItemLayout } from '../../../../modules/FormItems'

const { TextArea } = Input

function RoleForm(props) {
  const { getFieldDecorator } = props.form
  const { line } = props

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <Form.Item label="Name" {...defaultFormItemLayout}>
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: [{ required: true, message: "Name can't be empty " }],
            })(<Input placeholder="name" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Report To" {...defaultFormItemLayout}>
            {getFieldDecorator('reportto', {
              initialValue: get(line, 'reportto'),
            })(<Input placeholder="reportto" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Certification" {...defaultFormItemLayout}>
            {getFieldDecorator('certification', {
              initialValue: get(line, 'certification'),
            })(<TextArea placeholder="Certification" rows={4} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Description" {...defaultFormItemLayout}>
            {getFieldDecorator('description', {
              initialValue: get(line, 'description'),
            })(<TextArea placeholder="Description" rows={4} />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="task" {...defaultFormItemLayout}>
            {getFieldDecorator('task', {
              initialValue: get(line, 'task'),
              rules: [{ required: true, message: "task can't be empty " }],
            })(<TextArea placeholder="task" rows={4} />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()((RoleForm))
